import axios from "axios";

const swrFetcher = async ([url, params]) => {
  const { data } = await axios({
    url: params ? url + "?" + params : url,
  });
  return data;
};

export default swrFetcher;
